<template>
    <div class="card equal-height">
        <div class="card-image">
            <figure class="image"><!-- is-4by3 -->
                <a @click="goToTalk(talk.index)">
                    <img :src="talk.talk.video.thumb_2x || 'https://bulma.io/images/placeholders/1280x960.png'" alt="Placeholder image">
                </a>
            </figure>
        </div>
        <div class="card-content">
            <div class="media">
                <div class="">
                    <p class="is-size-4 has-text-weight-bold is-family-sans-serif">{{ talk.talk.title }}</p>
                </div>
            </div>
                    <div class="container card-date-category" style="height:80px; padding-top: 5px;">
                        <p class="subtitle is-6 is-pulled-left">{{ talk_date ? talk_date.getDate() : 'NaD' }} {{ talk_date ? talk_date.toLocaleString('default', { month: 'short' }) : 'NaM' }}</p>
                        <p class="subtitle tag is-6 is-pulled-right">{{ talk.stage ? talk.stage : 'No Category' }}</p>

                    </div>

            <div class="content">
                <p class="text-is-justified">
                    {{ talk.talk.description ? talk.talk.description.substring(0, 140) + '...'  : '' }}
                </p>
                
                <br>
                <div v-if="talk.talk.topics.nodes">
                    <p class="is-size-6 has-text-info">
                        <span style="margin-right:6px" v-for="tag in talk.talk.topics.nodes.slice(0, 3)" :key="tag.id">#{{tag.name}} </span>
                    </p>


                </div>
                <div v-else>
                    <a href="'#/tag/null'">
                        <span style="margin-right:6px">#null </span>
                    </a> 
                </div>


            </div>


            

        </div>

        <div class="card-footer has-text-centered">
            <!-- <div class="level-right">
                <a class="button" 
            
                @click="goToTalk(talk.index)"
                target="_self" 
                >
                    Open Video 
                </a>
            </div> -->

            <a @click="add_to_favorites(talk.index)" class="card-footer-item">
                <b-icon
                    :pack="favorites.includes(talk.index) ? 'fas' : 'far'"
                    size="large"
                    icon="star"
                ></b-icon>
                
            <!-- {{favorites.includes(talk.index)? 'Favorite!' : 'Fav'}} -->
            </a>
            <p class="card-footer-item"> </p>
            <a @click="goToTalk(talk.index)" class="card-footer-item button is-primary">WATCH</a>
        </div>

    </div>
</template>

<script>
export default {
    name: 'VideoCard',
    props: {
        talk: {
            date: String,
            stage: String,
            talk: Array,
        },
        favorites: Array
    },
    data: () => {
        return {
            //  project_date: new Date(Date.parse(this.project.date))
            // favorites: []
        }
    },
    created() {
        this.favorites = this.fetchFavorites()
    },
    computed: {
        talk_date() {
            return new Date(Date.parse(this.talk.talk.startDate))
        },
        // favorites(){
        //     let favs = JSON.parse(localStorage.getItem('favorites'))
        //     if (favs == null){
        //         favs = []
        //     }
        //     return favs
        // }
    },
    methods:{
        fetchFavorites(){
            let favs = JSON.parse(localStorage.getItem('favorites'))
            if (favs == null){
                favs = []
            }
            return favs
        },
        goToTalk(id){
            this.$router.push({ name: 'talk', params: { id: id } })
        },
        add_to_favorites(id){
            let favs = JSON.parse(localStorage.getItem('favorites'))
            if (favs == null){
                favs = []
            }
            if (!favs.includes(id)){
                favs.push(id)
            } else {
                var index = favs.indexOf(id)
                if (index !== -1) {
                    favs.splice(index, 1)
                }
            }
            // this.favorites = favs
            localStorage.setItem('favorites', JSON.stringify(favs))
            this.favorites = this.fetchFavorites()
        }
    }
}
</script>

<style>
.nav-logo {
    width: 30px;
}
.card-date-category {
    margin-top:-30px;
}

.title {
    font-size: 1.4rem;
}

.card {
    height: 100%;
}

.equal-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-footer {
  margin-top: auto;
}

.card-footer-item.button{
    margin-top:6px;
}
</style>